const configFunctionalKey = {
  pages: "page",
  questions: "question",
  columns: "column",
  rows: "row",
  choices: "choice",
  tempChoices: "choice"
};
export default configFunctionalKey;
